export default __webpack_public_path__ + "static/media/cLogo14.d0782ee5.jpeg";